exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cryptedmail:after{content:attr(data-name) \"@\" attr(data-domain) \".\" attr(data-tld)}", ""]);

// exports
